import { useQuery, UseQueryResult } from '@tanstack/react-query';
import axios from 'lib/axios';

export const useActiveContentGroups = (): UseQueryResult<any[]> => {
	return useQuery({
		queryKey: ['activeContentGroups'],
		queryFn: async() => {
			const { data: { contentGroups } } = await axios.get('/content-groups');
      return contentGroups.filter(c => c.active);
		}
	});
};